import { useEffect, useState } from 'react';
import { addLocaleData } from 'react-intl';

import { importWithRetry } from '@trello/use-lazy-component';

import { languageParts, currentLocale } from './language';

const getLocaleData = async (locale: string) => {
  switch (locale) {
    case 'cs':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-cs" */ 'react-intl/locale-data/cs'
          ),
      );
    case 'da':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-da" */ 'react-intl/locale-data/da'
          ),
      );
    case 'de':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-de" */ 'react-intl/locale-data/de'
          ),
      );
    case 'es':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-es" */ 'react-intl/locale-data/es'
          ),
      );
    case 'et':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-et" */ 'react-intl/locale-data/et'
          ),
      );
    case 'fi':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-fi" */ 'react-intl/locale-data/fi'
          ),
      );
    case 'fr':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-fr" */ 'react-intl/locale-data/fr'
          ),
      );
    case 'hu':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-hu" */ 'react-intl/locale-data/hu'
          ),
      );
    case 'is':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-is" */ 'react-intl/locale-data/is'
          ),
      );
    case 'it':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-it" */ 'react-intl/locale-data/it'
          ),
      );
    case 'ja':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-ja" */ 'react-intl/locale-data/ja'
          ),
      );
    case 'ko':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-ko" */ 'react-intl/locale-data/ko'
          ),
      );
    case 'nb':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-nb" */ 'react-intl/locale-data/nb'
          ),
      );
    case 'nl':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-nl" */ 'react-intl/locale-data/nl'
          ),
      );
    case 'pl':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-pl" */ 'react-intl/locale-data/pl'
          ),
      );
    case 'pt':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-pt" */ 'react-intl/locale-data/pt'
          ),
      );
    case 'ro':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-ro" */ 'react-intl/locale-data/ro'
          ),
      );
    case 'ru':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-ru" */ 'react-intl/locale-data/ru'
          ),
      );
    case 'sk':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-sk" */ 'react-intl/locale-data/sk'
          ),
      );
    case 'sv':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-sv" */ 'react-intl/locale-data/sv'
          ),
      );
    case 'th':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-th" */ 'react-intl/locale-data/th'
          ),
      );
    case 'tr':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-tr" */ 'react-intl/locale-data/tr'
          ),
      );
    case 'uk':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-uk" */ 'react-intl/locale-data/uk'
          ),
      );
    case 'vi':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-vi" */ 'react-intl/locale-data/vi'
          ),
      );
    case 'zh':
      return importWithRetry(
        () =>
          import(
            /*webpackChunkName: "react-intl-locale-zh" */ 'react-intl/locale-data/zh'
          ),
      );

    default:
      return importWithRetry(
        () =>
          import(
            /* webpackChunkName: "react-intl-locale-en" */ 'react-intl/locale-data/en'
          ),
      );
  }
};

export const useReactIntlLocale = () => {
  const [isLocaleReady, setIsLocaleReady] = useState(false);
  const { language } = languageParts(currentLocale);

  useEffect(() => {
    const setLocaleData = async () => {
      try {
        const localeData = await getLocaleData(language);
        addLocaleData(localeData.default);
        setIsLocaleReady(true);
      } catch (error) {
        setIsLocaleReady(true);
      }
    };
    setLocaleData();
  }, [language]);

  return {
    language,
    isLocaleReady,
  };
};
